/**
 * Choose the shipment details page layout.
 * The payload flag is the shipper on that shipment.
 * The company flag is the signed-in shipper's workflow setting, used until the payload arrives.
 */
export const isShipmentDetailsRevampEnabled = (
  payloadFlag: boolean | undefined,
  companyFlag: boolean | undefined,
): boolean => (typeof payloadFlag === "boolean" ? payloadFlag : Boolean(companyFlag));
